import "../src/styles/listenNow.css";

function MobileListenNow() {

  return (
    <div>
      <div className="mobileListenNowContainer">
        <div className="tock-class">
          <div
            className="tock"
            data-tockify-component="calendar"
            data-tockify-calendar="kxcjfm"
            data-tockify-height="550px"
            data-tockify-max-width="850px"
          ></div>
        </div>
      </div>
    </div>
  );
}

export default MobileListenNow;
